export default [
  { id: 1, descripcion: 'Almagro', provinciaId: '1' },
  { id: 2, descripcion: 'Balvanera', provinciaId: '1' },
  { id: 5, descripcion: 'Belgrano', provinciaId: '1' },
  { id: 7, descripcion: 'Caballito', provinciaId: '1' },
  { id: 8, descripcion: 'Chacarita', provinciaId: '1' },
  { id: 9, descripcion: 'Coghlan', provinciaId: '1' },
  { id: 10, descripcion: 'Colegiales', provinciaId: '1' },
  {
    id: 11,
    descripcion: 'Constitucion',
    provinciaId: '1',
  },
  { id: 12, descripcion: 'Flores', provinciaId: '1' },
  { id: 13, descripcion: 'Floresta', provinciaId: '1' },
  { id: 14, descripcion: 'La Boca', provinciaId: '1' },
  { id: 15, descripcion: 'La Paternal', provinciaId: '1' },
  { id: 16, descripcion: 'Liniers', provinciaId: '1' },
  { id: 17, descripcion: 'Mataderos', provinciaId: '1' },
  {
    id: 18,
    descripcion: 'Monte Castro',
    provinciaId: '1',
  },
  { id: 19, descripcion: 'Montserrat', provinciaId: '1' },
  {
    id: 20,
    descripcion: 'Nueva Pompeya',
    provinciaId: '1',
  },
  { id: 21, descripcion: 'Nuñez', provinciaId: '1' },
  { id: 22, descripcion: 'Palermo', provinciaId: '1' },
  {
    id: 23,
    descripcion: 'Parque Avellaneda',
    provinciaId: '1',
  },
  {
    id: 24,
    descripcion: 'Parque Chacabuco',
    provinciaId: '1',
  },
  { id: 25, descripcion: 'Parque Chas', provinciaId: '1' },
  {
    id: 26,
    descripcion: 'Parque Patricios',
    provinciaId: '1',
  },
  {
    id: 27,
    descripcion: 'Puerto Madero',
    provinciaId: '1',
  },
  { id: 28, descripcion: 'Recoleta', provinciaId: '1' },
  { id: 29, descripcion: 'Retiro', provinciaId: '1' },
  { id: 30, descripcion: 'Saavedra', provinciaId: '1' },
  {
    id: 31,
    descripcion: 'San Cristobal',
    provinciaId: '1',
  },
  { id: 32, descripcion: 'San Nicolas', provinciaId: '1' },
  { id: 33, descripcion: 'San Telmo', provinciaId: '1' },
  {
    id: 34,
    descripcion: 'Velez Sarsfield',
    provinciaId: '1',
  },
  { id: 35, descripcion: 'Versalles', provinciaId: '1' },
  {
    id: 36,
    descripcion: 'Villa Crespo',
    provinciaId: '1',
  },
  {
    id: 37,
    descripcion: 'Villa del Parque',
    provinciaId: '1',
  },
  {
    id: 38,
    descripcion: 'Villa Devoto',
    provinciaId: '1',
  },
  { id: 39, descripcion: 'Villa Luro', provinciaId: '1' },
  {
    id: 40,
    descripcion: 'Villa General Mitre',
    provinciaId: '1',
  },
  {
    id: 41,
    descripcion: 'Villa Lugano',
    provinciaId: '1',
  },
  {
    id: 42,
    descripcion: 'Villa Ortuzar',
    provinciaId: '1',
  },
  {
    id: 43,
    descripcion: 'Villa Pueyrredón',
    provinciaId: '1',
  },
  { id: 44, descripcion: 'Villa Real', provinciaId: '1' },
  {
    id: 45,
    descripcion: 'Villa Riachuelo',
    provinciaId: '1',
  },
  {
    id: 46,
    descripcion: 'Villa Santa Rita',
    provinciaId: '1',
  },
  {
    id: 47,
    descripcion: 'Villa Soldati',
    provinciaId: '1',
  },
  {
    id: 48,
    descripcion: 'Villa Urquiza',
    provinciaId: '1',
  },
  { id: 140, descripcion: 'Tribunales', provinciaId: '1' },
  { id: 173, descripcion: 'Once', provinciaId: '1' },
  { id: 176, descripcion: 'Paternal', provinciaId: '1' },
  {
    id: 49,
    descripcion: 'San Antonio de Padua',
    provinciaId: '2',
  },
  { id: 50, descripcion: 'Caseros', provinciaId: '2' },
  { id: 51, descripcion: 'Quilmes', provinciaId: '2' },
  { id: 52, descripcion: 'Olivos', provinciaId: '2' },
  { id: 53, descripcion: 'Moreno', provinciaId: '2' },
  { id: 54, descripcion: 'San Martín', provinciaId: '2' },
  { id: 55, descripcion: 'Hurlingham', provinciaId: '2' },
  { id: 56, descripcion: 'Lomas de Zamora', provinciaId: '2' },
  { id: 57, descripcion: 'Monte Grande', provinciaId: '2' },
  { id: 58, descripcion: 'La Lucila', provinciaId: '2' },
  { id: 59, descripcion: 'Martinez', provinciaId: '2' },
  { id: 60, descripcion: 'Munro', provinciaId: '2' },
  { id: 61, descripcion: 'San Miguel', provinciaId: '2' },
  { id: 62, descripcion: 'Lanus Oeste ', provinciaId: '2' },
  { id: 63, descripcion: 'Pilar ', provinciaId: '2' },
  { id: 64, descripcion: 'San Isidro', provinciaId: '2' },
  { id: 65, descripcion: 'Moron', provinciaId: '2' },
  { id: 66, descripcion: 'Ramos Mejia', provinciaId: '2' },
  { id: 67, descripcion: 'Adrogue', provinciaId: '2' },
  { id: 68, descripcion: 'Villa Ballester', provinciaId: '2' },
  { id: 69, descripcion: 'Jose Leon Suarez', provinciaId: '2' },
  { id: 70, descripcion: 'Manuel Alberti', provinciaId: '2' },
  { id: 71, descripcion: 'Castelar', provinciaId: '2' },
  { id: 72, descripcion: 'Ituzaingo', provinciaId: '2' },
  { id: 73, descripcion: 'Vicente Lopez', provinciaId: '2' },
  { id: 74, descripcion: 'Haedo', provinciaId: '2' },
  { id: 75, descripcion: 'Burzaco', provinciaId: '2' },
  { id: 76, descripcion: 'Longchamps', provinciaId: '2' },
  { id: 77, descripcion: 'Merlo', provinciaId: '2' },
  { id: 80, descripcion: 'Canning', provinciaId: '2' },
  {
    id: 134,
    descripcion: 'Lomas del Mirador',
    provinciaId: '2',
  },
  { id: 145, descripcion: 'Florida', provinciaId: '2' },
  { id: 148, descripcion: 'General Pacheco', provinciaId: '2' },
  { id: 162, descripcion: 'Bellavista', provinciaId: '2' },
  {
    id: 167,
    descripcion: 'Ingeniero Maschwitz',
    provinciaId: '2',
  },
  { id: 171, descripcion: 'Tigre', provinciaId: '2' },
  { id: 79, descripcion: 'Coronel Suarez', provinciaId: '3' },
  { id: 81, descripcion: 'La Plata ', provinciaId: '3' },
  { id: 82, descripcion: 'Junin', provinciaId: '3' },
  { id: 83, descripcion: 'Mar del Plata', provinciaId: '3' },
  { id: 84, descripcion: 'Bahia Blanca', provinciaId: '3' },
  { id: 85, descripcion: '9 de Julio', provinciaId: '3' },
  { id: 86, descripcion: 'Lujan', provinciaId: '3' },
  { id: 87, descripcion: 'Mercedes', provinciaId: '3' },
  { id: 88, descripcion: 'Olavarria', provinciaId: '3' },
  { id: 89, descripcion: 'Pergamino', provinciaId: '3' },
  { id: 90, descripcion: 'Tandil', provinciaId: '3' },
  { id: 91, descripcion: 'Azul', provinciaId: '3' },
  { id: 92, descripcion: 'San Pedro', provinciaId: '3' },
  { id: 93, descripcion: 'Pehuajo', provinciaId: '3' },
  { id: 94, descripcion: 'Bragado', provinciaId: '3' },
  { id: 95, descripcion: 'Gral.Las Heras', provinciaId: '3' },
  { id: 96, descripcion: 'Escobar', provinciaId: '3' },
  { id: 97, descripcion: 'Cañuelas', provinciaId: '3' },
  { id: 98, descripcion: 'Saladillo', provinciaId: '3' },
  { id: 99, descripcion: 'Bolivar', provinciaId: '3' },
  { id: 100, descripcion: 'Baradero', provinciaId: '3' },
  { id: 102, descripcion: 'Chacabuco', provinciaId: '3' },
  { id: 141, descripcion: 'Campana', provinciaId: '3' },
  { id: 151, descripcion: 'Salto', provinciaId: '3' },
  { id: 153, descripcion: 'City Bell', provinciaId: '3' },
  { id: 158, descripcion: 'Vedia', provinciaId: '3' },
  { id: 159, descripcion: 'Chascomus', provinciaId: '3' },
  { id: 160, descripcion: 'Rojas', provinciaId: '3' },
  { id: 164, descripcion: '25 de Mayo', provinciaId: '3' },
  { id: 165, descripcion: 'Coronel Pringles', provinciaId: '3' },
  { id: 166, descripcion: 'Darregueira', provinciaId: '3' },
  { id: 168, descripcion: 'Tres Arroyos', provinciaId: '3' },
  { id: 177, descripcion: 'Necochea', provinciaId: '3' },
  { id: 180, descripcion: 'Coronel Brandsen', provinciaId: '3' },
  { id: 106, descripcion: 'Resistencia', provinciaId: '5' },
  {
    id: 172,
    descripcion: 'Presidencia Roque Saenz Peña',
    provinciaId: '5',
  },
  { id: 133, descripcion: 'Trelew', provinciaId: '6' },
  { id: 107, descripcion: 'Puerto Madryn', provinciaId: '6' },
  { id: 149, descripcion: 'Comodoro Rivadavia', provinciaId: '6' },
  { id: 150, descripcion: 'Sarmiento', provinciaId: '6' },
  { id: 108, descripcion: 'Cordoba', provinciaId: '7' },
  { id: 109, descripcion: 'Rio Cuarto', provinciaId: '7' },
  { id: 110, descripcion: 'Alta gracia', provinciaId: '7' },
  { id: 131, descripcion: 'Villa allende', provinciaId: '7' },
  { id: 157, descripcion: 'Laboulaye', provinciaId: '7' },
  { id: 163, descripcion: 'Villa María', provinciaId: '7' },
  { id: 178, descripcion: 'Bella Vista', provinciaId: '8' },
  { id: 111, descripcion: 'Corrientes', provinciaId: '8' },
  { id: 179, descripcion: 'Esquina', provinciaId: '8' },
  { id: 112, descripcion: 'Concepcion del Uruguay', provinciaId: '9' },
  { id: 132, descripcion: 'Parana', provinciaId: '9' },
  { id: 137, descripcion: 'Gualeguaychu', provinciaId: '9' },
  { id: 115, descripcion: 'Santa Rosa', provinciaId: '12' },
  { id: 103, descripcion: 'Tunuyan', provinciaId: '14' },
  { id: 104, descripcion: 'Mendoza', provinciaId: '14' },
  { id: 181, descripcion: 'Guaymallen', provinciaId: '14' },
  { id: 117, descripcion: 'Posadas', provinciaId: '15' },
  { id: 118, descripcion: 'San Martin de los Andes', provinciaId: '16' },
  { id: 142, descripcion: 'Zapala', provinciaId: '16' },
  { id: 144, descripcion: 'Neuquen', provinciaId: '16' },
  { id: 120, descripcion: 'Salta', provinciaId: '18' },
  { id: 121, descripcion: 'San Juan', provinciaId: '19' },
  { id: 122, descripcion: 'San Luis', provinciaId: '20' },
  { id: 124, descripcion: 'Santa Fe', provinciaId: '22' },
  { id: 125, descripcion: 'Rosario', provinciaId: '22' },
  { id: 129, descripcion: 'Teodolina', provinciaId: '22' },
  { id: 136, descripcion: 'Rufino', provinciaId: '22' },
  { id: 138, descripcion: 'Funes', provinciaId: '22' },
  { id: 139, descripcion: 'Galvez', provinciaId: '22' },
  { id: 146, descripcion: 'Rafaela', provinciaId: '22' },
  { id: 147, descripcion: 'Totoras', provinciaId: '22' },
  { id: 152, descripcion: 'Cañada de Gomez', provinciaId: '22' },
  { id: 155, descripcion: 'Venado Tuerto', provinciaId: '22' },
  { id: 127, descripcion: 'Ushuaia', provinciaId: '24' },
  { id: 128, descripcion: 'Tucuman', provinciaId: '25' },
  { id: 135, descripcion: 'Monteros', provinciaId: '25' },
  { id: 154, descripcion: 'Bariloche', provinciaId: '26' },
  { id: 156, descripcion: 'El Bolson', provinciaId: '26' },
  {
    id: 126,
    descripcion: 'Santiago del Estero',
    provinciaId: '28',
  },
  {
    id: 169,
    descripcion: 'San Fernando del Valle de Catamarca',
    provinciaId: '29',
  },
  { id: 170, descripcion: 'San Salvador de Jujuy', provinciaId: '30' },
  { id: 116, descripcion: 'La Rioja', provinciaId: '31' },
  { id: 113, descripcion: 'Formosa', provinciaId: '32' },
  { id: 174, descripcion: 'Rio Gallegos', provinciaId: '33' },
  { id: 175, descripcion: 'Rio Turbio', provinciaId: '33' },
  { id: 199, descripcion: 'Banfield', provinciaId: '2' },
].sort((a, b) => ((a.descripcion > b.descripcion) ? 1 : ((b.descripcion > a.descripcion) ? -1 : 0)));
